// Packages
import { createAsyncThunk } from '@reduxjs/toolkit';
// API
import { ContactsAPI } from 'api/endpoints';
// Interfaces and types
import {
  IGetContactsRes,
  ICreateContactRes,
  ICreateContactBody,
  IUpdateContactBodyWithParam,
  IUpdateContactRes,
  IGetContactParams,
  IGetContactRes,
  IDeleteContactRes,
  IDeleteContactParams,
} from 'types/contactTypes';
import { TQueryParams, IErrorRes } from 'types/appTypes';

const getContactsAsync = createAsyncThunk<
  IGetContactsRes,
  TQueryParams,
  { rejectValue: IErrorRes }
>('contacts/getContacts', async (params: TQueryParams, { rejectWithValue }) => {
  try {
    return await ContactsAPI.getContacts(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const createContactAsync = createAsyncThunk<
  ICreateContactRes,
  ICreateContactBody,
  { rejectValue: IErrorRes }
>('contacts/createContact', async (cred: ICreateContactBody, { rejectWithValue }) => {
  try {
    return await ContactsAPI.createContact(cred);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const getContactDetailsAsync = createAsyncThunk<
  IGetContactRes,
  IGetContactParams,
  { rejectValue: IErrorRes }
>('contacts/getContact', async (cred: IGetContactParams, { rejectWithValue }) => {
  try {
    return await ContactsAPI.getContact(cred);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const updateContactAsync = createAsyncThunk<
  IUpdateContactRes,
  IUpdateContactBodyWithParam,
  { rejectValue: IErrorRes }
>('contacts/update', async (cred: IUpdateContactBodyWithParam, { rejectWithValue }) => {
  try {
    return await ContactsAPI.updateContact(cred);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

const deleteContactAsync = createAsyncThunk<
  IDeleteContactRes,
  IDeleteContactParams,
  { rejectValue: IErrorRes }
>('contact/delete', async (params: IDeleteContactParams, { rejectWithValue }) => {
  try {
    return await ContactsAPI.deleteContact(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

export {
  getContactsAsync,
  createContactAsync,
  updateContactAsync,
  getContactDetailsAsync,
  deleteContactAsync,
};
